<template>
  <IncompleteBookingsComponent
    :bookings="shapedBookings"
    :new-hours-are-valid="newHoursAreValid"
    v-on:save="save"
    v-on:cancel="cancel"
  />
</template>

<script>
import moment from 'moment-timezone'
import * as _ from 'lodash-es'

import alertService from '../../common/service/alertService.js'
import jobService from '../../job/service/jobService.js'
import logService from '../../common/service/logService.js'
import incompleteBookingsService from '../service/incompleteBookingsService.js'
import IncompleteBookingsComponent from './incompleteBookingsComponent.vue'

// The incomplete-bookings slide-out host (step 15b of #614). This is `IncompleteBookingsCtrl` as a
// Vue component: it shapes the rows the view renders and owns the range check, which is still
// unit-tested directly (`incompleteBookingsCtrl.test.js` covers the same logic).
//
// `close` resolves the slide-out promise (saved); `dismiss` rejects it - the controller's cancel
// called `$uibModalInstance.dismiss()`, and `ResourcesService.openIncompleteBookings` re-reads the
// list on either path.
export default {
  name: 'IncompleteBookingsSlider',
  components: { IncompleteBookingsComponent },
  props: {
    bookings: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    shapedBookings() {
      return (this.bookings || []).map(booking => {
        booking.duration = moment.duration(moment(booking.endsAt).diff(moment(booking.startsAt))).humanize()
        booking.resources = booking.resource.sort().join(', ')
        return booking
      })
    },
  },
  methods: {
    // Was IncompleteBookingsCtrl.newHoursAreValid. Renders the range error.
    newHoursAreValid(bookingStart, hours) {
      hours = _.toNumber(hours)
      let start = moment(bookingStart)
      let end = moment(start).add(hours, 'hour')
      let midnight = moment(start).add(1, 'day').startOf('day')

      return _.isNumber(hours) && hours >= 0 && end.isSameOrBefore(midnight)
    },
    save(incompleteBookings) {
      incompleteBookingsService
        .updateBookings(incompleteBookings)
        .then(() => jobService.refreshAllJobs())
        .then(() => {
          this.$emit('close', 1)
          alertService.add('success', 'Booking times updated and completed')
        })
        .catch(err => {
          logService.log(err)
          console.log(err)
        })
    },
    cancel() {
      this.$emit('dismiss')
    },
  },
}
</script>
